import React from 'react';
import { ActionModal } from '@insurancemenu/imenu-components-lib';
import { ActionModalProps } from '@insurancemenu/imenu-components-lib/dist/types/ActionModal';
import { GroupNameStyled } from './styles';

interface Props extends Omit<ActionModalProps, 'title' | 'subtitle' | 'closeButtonText' | 'actionButtonText'> {
  groupName: string;
}

const ArchiveGroupModal: React.FC<Props> = ({ groupName, ...rest }) => {
  return (
    <ActionModal
      title="Attention"
      subtitle={
        <>
          You are about to archive <GroupNameStyled>{groupName}</GroupNameStyled> group. You will no longer be able to
          create proposals for this group unless you unarchive this group first.
        </>
      }
      closeButtonText="Cancel"
      actionButtonText="Archive"
      {...rest}
    />
  );
};

export default ArchiveGroupModal;
